<template>
  <div class="btn_area type_fr">
    <button
      type="button"
      class="btn_default"
      :style="{minWidth: '150px'}"
      :disabled="isLoading"
      @click="onClickButton"
    >{{buttonText}}</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      isPlaying: false,
      src: null,
      audioPlayer: null,
      oldPlayContent: null
    };
  },
  computed: {
    buttonText() {
      if (this.isLoading) return "loading";
      else if (this.isPlaying) return "멈춤";
      else return "TTS 미리듣기";
    },
    useBgsoundTag() {
      return this.$utils.isIE && /\.wav$/.test(this.src)
    }
  },
  methods: {
    onClickButton() {
      if (this.isPlaying) this.pause();
      else this.$emit("click");
    },
    loadAndPlay(content) {
      if (this.oldPlayContent === content) {
        this.play();
        return;
      }
      this.isLoading = true;
      this.$axios
        .get("/admin/tts", {
          params: {
            text: content.trim()
          }
        })
        .then(res => {
          this.src = res.data;
          this.oldPlayContent = content;
          this.play();
        })
        .catch(err => {
          //error
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    createInstance() {
      if (this.useBgsoundTag) {
        let tag = document.querySelector('#bgsound');
        if (!tag) {
          tag = document.createElement("bgsound");
          tag.id = "bgsound";
          document.querySelector('body').appendChild(tag);
        }
        this.audioPlayer = tag;
      } else {
        const audio = new Audio();
        audio.addEventListener("play", this.onPlay);
        audio.addEventListener("pause", this.onPause);
        this.audioPlayer = audio;        
      }
    },
    onPlay() {
      this.isPlaying = true;
    },
    onPause() {
      this.isPlaying = false;
    },
    play() {
      if (!this.audioPlayer) this.createInstance();
      if (this.useBgsoundTag) {
        this.audioPlayer.volume = 0;
        this.audioPlayer.src = this.src;
      } else {
        this.audioPlayer.src = this.src;
        this.audioPlayer.currentTime = 0;
        this.audioPlayer.play();
      }
    },
    pause() {
      if (!this.audioPlayer) return;
      if (this.useBgsoundTag) {
        this.audioPlayer.volume = -10000;
      } else {
        this.audioPlayer.pause();
        this.audioPlayer.currentTime = 0;
      }
    },
    focus() {
      this.$el.querySelector("button").focus();
    }
  },
  beforeDestroy() {
    this.pause();
  }
};
</script>
